import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import Alert from "../../Common/Alert";
import DatatableFunc from "../../Common/DatatableFunc";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import ReactDataTable from "../../Common/ReactDataTable";

const ProductionWiseStock = () => {
  const location = useLocation();

  const [productionStaff, setProductionStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [alert, setAlert] = useState(null);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [inputs, setInputs] = useState({
    from_date: getTodayDate(),
    to_date: getTodayDate(),
    production_staff_id: "",
  });

  const showAlert = (message, type) => {
    setAlert({ message, type });

    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  const fetchProductionStaff = async () => {
    try {
      const res = await Http.get("/staff2?user_type=production");
      setProductionStaff(res.data || []);
    } catch (error) {
      console.error("Error fetching production staff:", error);
      showAlert("Error fetching production staff", "error");
    }
  };

  const fetchData = () => {
    setLoading(true);

    const params = new URLSearchParams();

    params.append("type", "with_product_group_wise_stock");
    params.append("user_type", "production");

    if (inputs.production_staff_id && inputs.production_staff_id !== "") {
      params.append("production_staff_id", inputs.production_staff_id);
    }

    Http.get(`/production-wise-stock?${params.toString()}`)
      .then((res) => {
        setReportData(res.data?.data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching Kitchen wise stock data:", error);
        setLoading(false);
        showAlert("Error fetching Kitchen wise stock data", "error");
      });
  };

  useEffect(() => {
    DatatableFunc();
    fetchProductionStaff();
    fetchData();
  }, []);

  useEffect(() => {
    if (!location.state) return;

    showAlert(location.state.message, location.state.type);
  }, [location]);

  const selectHandleChange = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption ? selectedOption.value : "";

    setInputs((values) => ({
      ...values,
      [name]: value,
    }));
  };

  const formSubmit = () => {
    fetchData();
  };

  const clearFilters = () => {
    setInputs({
      from_date: getTodayDate(),
      to_date: getTodayDate(),
      production_staff_id: "",
    });

    setTimeout(() => {
      fetchData();
    }, 100);
  };

  const productionCols = useMemo(() => {
    const baseCols = [
      { field: "code", header: "Product Code" },
      { field: "name", header: "Product Name" },
    ];

    if (!reportData.length) {
      return baseCols;
    }

    const dynamicStockCols = Object.keys(reportData[0])
      .filter((key) => key.startsWith("stock_qty_"))
      .map((key) => {
        const staffId = key.replace("stock_qty_", "");

        const staff = productionStaff.find(
          (item) => String(item.value) === String(staffId)
        );

        return {
          field: key,
          header: staff ? staff.label : `Staff ${staffId}`,
        };
      });

    return [...baseCols, ...dynamicStockCols];
  }, [reportData, productionStaff]);

  return (
    <div>
      <IsLogin />

      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Kitchen Wise Stock</h5>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-sm-40">
              <div className="row">
                <div className="col-lg-10">
                  <label htmlFor="">Select Kitchen</label>

                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    name="production_staff_id"
                    options={productionStaff.filter(
                      (staff) =>
                        staff.value &&
                        staff.value !== "" &&
                        staff.label !== "Select Staff"
                    )}
                    onChange={selectHandleChange}
                    isClearable={true}
                  />
                </div>

                <div className="col-lg-2">
                  <label className="form-label">&nbsp;</label>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-primary btn-block"
                      onClick={formSubmit}
                      disabled={loading}
                    >
                      <i className="fa fa-search mg-r-10"></i>
                      {loading ? "Searching..." : "Search"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card pd-20 pd-sm-40 mt-4">
              <h5 className="card-body-title">Kitchen Wise Stock Report</h5>
              <hr />

              <ReactDataTable
                cols={productionCols}
                receiveData={reportData}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductionWiseStock;